import baseMetaObject from "core/services/metaStoreService/metaObjects/base-meta-object";

var module = {};

module.Model = baseMetaObject.Model.extend({
    defaults: {
        type: "PAGE",
        title: String,
        gridJSON: Object,
        queryVisualizations: Array,
    },
    parse: function (data) {
        if (data === undefined) return;
        data.gridJSON = JSON.parse(data.gridJSON);
        return data;
    },
});

module.Collection = baseMetaObject.Collection.extend({
    model: module.Model,
});

export default module;
